import {useContext} from 'react';
import {useQuery} from '@tanstack/react-query';
import {ApiEnv} from '@/api/dto/state-config';
import {CarecoApiContext} from '@/app-context/careco-api-context';
import {useRosterStore} from '@/store/roster_store';

export function getEnv<T>(stateConfig: ApiEnv<T> | undefined): T | undefined {
  if (stateConfig) {
    switch (process.env.REACT_APP_ENV) {
    case 'local':
    case 'dev':
      return stateConfig.dev;
    case 'qa':
      return stateConfig.qa;
    case 'sandbox':
      return stateConfig.sandbox;
    case 'prod':
      return stateConfig.prod;
    default:
      throw new TypeError(`Unknown React environment: ${process.env.REACT_APP_ENV}`);
    }
  }
}

export function useStateConfig() {
  const { carecoApi } = useContext(CarecoApiContext);
  const selectedRoster = useRosterStore((state) => state.selectedRoster);

  const { data: stateConfig } = useQuery({
    queryKey: ['stateConfig', selectedRoster?.id],
    queryFn: () => carecoApi?.getStateConfig(selectedRoster?.id),
    placeholderData: (prev) => prev,
    enabled: !!carecoApi,
  });

  return stateConfig;
}
